<template>
    <div>
        <!-- <b-button v-b-modal.video-modal-1>video test</b-button> -->
        <a href="#" style="margin-left: -16px; padding-left: 8px;" v-b-modal.video-modal-test-1 @click="modalOpened()">View NFT Transition</a>

        <b-modal id="video-modal-test-1" title="NFT Update" modal-class="modal">
            <div class="video-container">

                <video v-if="showPlaceholder" style="width: 100%; height: 100%;" playsinline poster="https://mcaloon.org/firstFrame.png">                    
                </video>

                <video v-if="showVideo" style="width: 100%; height: 100%;" playsinline autoplay poster="https://mcaloon.org/firstFrame.png" @play="onStart()" @ended="onEnd()">                    
                    <source src="https://mcaloon.org/c5a0fb5cf20768bb45e4720ec84df0de8fbfc550f2615024d37968b7bc7603e6.mp4" type="video/mp4">
                </video>

                <!-- text overlay -->
                <div class="text-background" :class="[showStartTextOverlay ? '' : 'animate__animated animate__fadeOut']">
                    <div v-if="showStartText" class="video-overlay-text animate__animated animate__fadeIn" :class="[hideStartText ? 'animate__animated animate__fadeOut' : '']">
                        Your genetic pack is being cryopreserved and protected by Vitrafy.
                    </div>
                </div>

                <div v-if="showEndTextOverlay" class="text-background animate__animated animate__fadeIn">
                    <div v-if="showEndText" class="video-overlay-text animate__animated animate__fadeIn">
                        Protected by Vitrafy. Ready for storage.
                    </div>
                </div>                

            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: 'NFTVideoModal',
        components: {
        },
        data: function () {
            return {
                test: 'test 123',
                showStartTextOverlay: true,
                showStartText: false,
                hideStartText: false,
                showPlaceholder: true,
                showVideo: false,
                showEndTextOverlay: false,
                showEndText: false,   
            }
        },
        computed: {},
        props: [],
        watch: {
        },
        methods: {
            modalOpened() {
                // initial state
                this.showStartTextOverlay = true;
                this.showStartText = false;
                this.hideStartText = false;
                this.showPlaceholder = true;
                this.showVideo = false;
                this.showEndTextOverlay = false;
                this.showEndText = false;                

                // show text after 1 second
                setTimeout(() => {
                    this.showStartText = true;
                }, 1000);

                // hide text after 4 seconds
                setTimeout(() => {
                    this.hideStartText = true;
                }, 4000);            
                                
                // hide first text overlay after 3 seconds
                setTimeout(() => {
                    this.showStartTextOverlay = false;              
                }, 5000);

                // start video after 2 seconds
                setTimeout(() => {
                    this.showVideo = true;       
                    this.showPlaceholder = false;
                }, 3000);             
            },
            onStart: function() {
                console.log('Video Started');
                setTimeout(() => {
                    this.showEndTextOverlay = true;              
                }, 25000);
                
                setTimeout(() => {
                    this.showEndText = true;              
                }, 26000);                    
            },
            onEnd: function () {
                console.log('Video Ended');
            }            
        },
        mounted: function () {
        },
        created() {
        
        }        
    }
</script>

<style>
    #video-modal-test-1___BV_modal_header_,
    #video-modal-test-1___BV_modal_footer_ {
        display: none;
    }

    #video-modal-test-1___BV_modal_body_ {
        padding: 5px;
        margin-bottom: -5px;
    }

    .video-container {
        position: relative;
    }

    .text-background {
        position: absolute;
        top: 0;
        left: 0;   
        width: 100%;
        height: 100%;
        background-color: #fff;
    }

    .video-overlay-text {
        position: absolute;
        width: 100%;
        background-color: #fff;
        top: 37%;
        left: 0;
        text-align: center;
        font-size: 32px;
        padding: 30px;
    }

    .animate__animated.animate__fadeOut {
        --animate-duration: 1s;
    }

    .animate__animated.animate__fadeIn {
        --animate-duration: 1s;
    }       
</style>